import React, { useEffect, useState } from "react";

import { useContext } from "react";
import { AppContext } from "components/app/RemExprertProvider";
import CardBox from "components/ui/controls/card-box/card-box";
import Column from "components/ui/layout/column/column";
import Row from "components/ui/layout/row/row";
import Button from "components/ui/controls/button/button";
import TextField from "components/ui/controls/text-field/text-field";
import { FaCalculator, FaSync } from "react-icons/fa";
import { CalculPrestationContrat, CalculRetraite } from "components/app/Api/Retraite/ApiRetraite";
const PrestationsPerp = (props) => {
  const { ClientConjoint } = props;
  const context = useContext(AppContext);
  const [AnnneDepartRetraite, SetAnneeDepartRetraite] = useState(0);

  const handleCalculRetraite = () => {
    CalculRetraite(context.state, "", 0, ClientConjoint).then((ResultatRetraite) => {
      CalculPrestationContrat(context.state, ClientConjoint, ResultatRetraite, "").then((Resultat) => {
        context.handleValueChange("CotisationContratRetraite", Resultat.TabCotisations);
        context.handleValueChange("TableauSaisieManuelleRente", Resultat.TabPrestations);
        SetAnneeDepartRetraite(Number(ResultatRetraite.RetraiteChoixDepartRetraite.Infos.DateDepartRetraite.slice(0, 4)));
      });
    });
  };
  useEffect(() => {
    handleCalculRetraite();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const LignePrestation = (Annee) => {
    return (
      Object.keys(context.state.TableauSaisieManuelleRente).length> 0 && (
        <tr>
          <td>{context.state.TableauSaisieManuelleRente[Annee]["AnneeDepartRetraiteAffich"]}</td>
          <td>{context.state.TableauSaisieManuelleRente[Annee]["Age"]}</td>
          <td>
            <TextField
              iconBefore={
                <Button
                  icon
                  onClick={(e) => {
                    context.handleSaisieManuelleRente(Annee, "RenteSaisi", e);
                  }}
                >
                  {!context.state.TableauSaisieManuelleRente[Annee]["RenteSaisi"] ? <FaCalculator /> : <FaSync style={{ color: "green" }} />}
                </Button>
              }
              value={context.state.TableauSaisieManuelleRente[Annee]["Rente"]}
              disabled={context.state.SortieContratRetraite === "RenteCapital" ? true : false}
              dataType="uint"
              format={{ thousands: " ", unit: " €" }}
              onChange={(e) => {
                context.handleSaisieManuelleRente(Annee, "Rente", e);
              }}
              normal
            />
          </td>
          <td>
            <TextField
              iconBefore={
                <Button
                  icon
                  onClick={(e) => {
                    context.handleSaisieManuelleRente(Annee, "PartProduitSaisi", e);
                  }}
                >
                  {!context.state.TableauSaisieManuelleRente[Annee]["PartProduitSaisi"] ? <FaCalculator /> : <FaSync style={{ color: "green" }} />}
                </Button>
              }
              value={Number(context.state.TableauSaisieManuelleRente[Annee]["PartVersement"]) + Number(context.state.TableauSaisieManuelleRente[Annee]["PartProduit"])}
              dataType="uint"
              disabled={context.state.SortieContratRetraite === "RenteSimple" ? true : false}
              format={{ thousands: " ", unit: " €" }}
              onChange={(e) => {
                context.handleSaisieManuelleRente(Annee, "PartProduit", e);
              }}
              normal
            />
          </td>
        </tr>
      )
    );
  };

  return (
    <>
      <Column fill>
        <CardBox bpad>
          <Column fill>
            <Column fill>
              <Row>
                <blockquote>
                  Les prestations sont automatiquement calculées en fonction des paramètres que vous avez renseignés. Vous avez toutefois la possibilité de modifier directement le montant
                  dans les cases.
                </blockquote>
              </Row>
            </Column>
            <Row tpad>
              <Column fill>
                <table className="mono">
                  <thead>
                    <tr>
                      <th>Année</th>
                      <th>Age</th>
                      <th>Rente brute annuelle</th>
                      <th>Capital au terme</th>
                    </tr>
                  </thead>
                  <tbody>
                    {AnnneDepartRetraite > 0 && (
                      <>
                        {LignePrestation(AnnneDepartRetraite)}
                        {LignePrestation(AnnneDepartRetraite + 1)}
                        {LignePrestation(AnnneDepartRetraite + 2)}
                        {LignePrestation(AnnneDepartRetraite + 3)}
                        {LignePrestation(AnnneDepartRetraite + 4)}
                        {LignePrestation("TauxPlein")}
                      </>
                    )}
                  </tbody>
                </table>
              </Column>
            </Row>
          </Column>
        </CardBox>
      </Column>
    </>
  );
};

export default PrestationsPerp;
